module.exports = __webpack_public_path__ + "img/prescription.943af74c.jpg";